/**
 * This is for passing keys back and forth to track which sections are submitting the save requests
 */
export enum SYSTEM_ADMIN_SECTION {
  FEATURE_TOGGLES,
  TIMEOUTS,
}
